module.exports = __webpack_public_path__ + "img/core2.90d21ccf.png";